export const STATUS_COLORS = {
  geplant: "info",
  abgesagt: "error",
  abgeschlossen: "success",
};

export const STATUS_LABELS = {
  geplant: "Geplant",
  abgesagt: "Abgesagt",
  abgeschlossen: "Abgeschlossen",
};

export const EVENT_TYPE_LABELS = {
  EVENT: "Veranstaltung",
  TESTING: "Prüfung",
  SEMINAR: "Seminar",
};

export const EVENT_TYPE_ACCENT = {
  TESTING: "#6366f1",
  SEMINAR: "#f59e0b",
  EVENT: "#64748b",
};

export const BOOKING_ACCENT = "#0284c7";

export const ACTION_BUTTON_SX = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: 1.8,
  minHeight: 38,
  px: 1,
  py: 0.5,
  fontSize: "0.8rem",
  lineHeight: 1.3,
  whiteSpace: "nowrap",
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "& .MuiButton-startIcon": { mr: 0.5, ml: 0 },
};

export const PRIMARY_ACTION_BUTTON_SX = {
  ...ACTION_BUTTON_SX,
  minHeight: 40,
  fontSize: "0.85rem",
  justifyContent: "center",
  textAlign: "center",
};

export const ACTION_GRID_SX = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
  gap: 0.75,
  minWidth: 0,
};

export const toEventTypeLabel = (eventType) => {
  const key = String(eventType || "").trim().toUpperCase();
  return EVENT_TYPE_LABELS[key] || eventType || "Veranstaltung";
};
